module.exports = __webpack_public_path__ + "img/Weekdays.e55a7722.svg";